import createSharedStateHook from './Shared/use-shared-state.js';

export const useSelectedOptionid = createSharedStateHook('selectedOptionid');
export const setSelectedOptionid = useSelectedOptionid.set;
export const useInternationalBuyBox = createSharedStateHook('internationalBuyBoxVisible', true);
export const setInternationalBuyBox = useInternationalBuyBox.set;
